interface InfoCardProps {
    label: string
    value?: string | number
    subtitle?: string
}

export default function InfoCard({ label, value, subtitle }: InfoCardProps) {
    return (
        <div className="py-4 px-6">
            <p className="text-muted-foreground text-sm mb-1">{label}</p>
            <p className="text-foreground text-xl font-bold">{value ?? '-'}</p>
            {subtitle !== null && (
                <p className="text-muted-foreground text-sm">{subtitle}</p>
            )}
        </div>
    )
}
